var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"disabled":_vm.disabled,"tag":"router-link","to":_vm.to}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm.name)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }